/* eslint-disable @typescript-eslint/no-explicit-any */
import { useMutation } from '@tanstack/react-query';
import { apiClient } from '@lib/api-client';
import { queryClient } from '@lib/react-query';
import { notifications } from '@mantine/notifications';
// I18n
import { useTranslation } from 'react-i18next';
import { TMesurabilityProject } from '../types';
import { TParams } from '@global-types/index';

export const remove = (
	id: string
): Promise<TMesurabilityProject> => {
	return apiClient.delete(`/measurabilities/${id} `);
};

export const useRemove = (
	page: number,
	size: number,
	queryParams: TParams,
	sortParams: string
) => {
	const { t } = useTranslation();
	const { mutate, isPending: isLoading } = useMutation({
		mutationFn: remove,
		onSuccess: () => {
			notifications.show({
				title: t('global.success'),
				message: t(
					'measurabilities.notifications.measurabilitiesSuccessfullyDeleted'
				),
				color: 'success',
			});
			queryClient.invalidateQueries({
				queryKey: [
					'databases-measurabilities',
					{
						page: page,
						size: size,
						queryParams: queryParams,
						sortParams: sortParams,
					},
				],
			});
		},
		onError: (error: any) => {
			notifications.show({
				title: t('global.error'),
				message: t(`api.${error.type}`),
				color: 'error',
			});
		},
	});

	return { mutate, isLoading };
};
